import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import routes from "./dom.router.config";
import { ProtectedRoute } from "./auth/protectedRoute"; // <-- casse importante
import Loading from "./views/Loading";

function App() {
  return (
    <Router basename="/">
      <Suspense fallback={<Loading />}>
        <Routes>
          {routes.map((route, idx) => {
            const { path, element, roles = [] } = route;

            // Cas particulier : la route vers login (publique)
            if (path === "/login") {
              const Element = element;
              return <Route key={idx} path={path} element={<Element />} />;
            }

            // Si c’est déjà un élément JSX (ex: <Navigate ... />)
            if (React.isValidElement(element)) {
              return <Route key={idx} path={path} element={element} />;
            }

            // Sinon, c’est un composant protégé
            const Element = element;
            return (
              <Route
                key={idx}
                path={path}
                element={<ProtectedRoute element={Element} roles={roles} />}
              />
            );
          })}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
